import React from 'react';
import styled, {css} from 'styled-components';

import Logo from "./components/Logo";
import Menu from "./components/Menu";

let HEADER = styled.header`
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 1000;

  border-bottom: 1px solid #dadce0;
  background-color: rgba(255, 255, 255, 1);
`;
let HEADER_BAR = styled.div`
  /* 위치 */
  position: relative;
  top: 0;
  right: 0;
  
  /* 모양 */
  height: 56px; /* 헤더바의 높이를 56px 로 정함 */
  max-width: 1440px;
  padding: 0 24px;
  margin-left: auto;
  margin-right: auto;
  
  /* flexbox 화 및 내부배치 */
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

function Header() {
  return (
    <HEADER className="Header">
      <HEADER_BAR className="HeaderBar">
        <Logo/>
        <Menu/>
      </HEADER_BAR>
    </HEADER>
  );
}

export default Header;
